import { ErrorType } from "./ErrorType";

export class GeneralError {
    message = "";
    shortMessage = "";
    errorType: ErrorType;
}
